import { createSelector } from 'reselect';
import cookieManagerHelper from 'Helpers/cookies';

export const getLanguageList = createSelector(
    (_, props) => ((props.marketConfig && props.marketConfig.get('langs')) || (props.config && props.config.get('langs'))),
    langs => {
        return langs;
    }
);

export const getSelectedLang = createSelector(
    getLanguageList,
    state => state.api && state.api.queryParam && state.api.queryParam.enableMultiLang && state.api.queryParam.lang,
    (langs, lang) => {
        const langSelect = cookieManagerHelper.readCookie('lang');

        if (langSelect) {
            return langSelect;
        }
        else if (lang) {
            return lang;
        }
        else if (langs && langs.length) {
            return langs[0].param || langs[0].code;
        }
        return null;
    });

export const getSelectedLangLabel = createSelector(
    (_, props) => (props.marketConfig.get('langs')),
    getSelectedLang,
    (langs, selectLang) => {
        if (Array.isArray(langs)) {
            const obj = langs.find(lang => lang.code === selectLang);

            return obj && obj.name;
        }
        return '';
    });
